import deepclone from "lodash.clonedeep"
import Objdict from "objdict"

import Geometry from "@frog/source/utility/Geometry.js"
import isString from "@frog/source/utility/isString.js"

import Speedtest from "@frog/source/engine/testing/utility/Speedtest.js"
import * as Ribbit from "@frog/source/utility/integration/Ribbit.js"

import World from "@frog/source/models/World.js"
import Zone from "@frog/source/models/Zone.js"
import Unit from "@frog/source/models/Unit.js"
import Reactions from "@frog/source/models/Reactions.js"
import Action from "@frog/source/models/Action.js"



import Dev from "@frog/source/models/dev/Dev.js"

import skills from "@frog/source/data/skills.js"
import Step from "@frog/source/models/Step.js"

const MAX_INFLUENCE = 200 // TODO: this is duped from Unit.js

export default class Stage {
    static load({stage, player, hasPreparePhase, isRandomized, startingEncounter, chapterSlug, gameSlug, random}) {
        stage = deepclone(stage)
        stage.chapterSlug = chapterSlug
        stage.random = random

        // if(stage.reference != undefined) {
        //     if(stages[stage.reference] == undefined) {
        //         throw "Could not find stage with reference " + stage.reference
        //     }
        //
        //     // TODO: Even if the stage is referenced, it should merge
        //     // any overriding child properties on top of the reference!
        //     // But it should do it intelligently, like merging units instead
        //     // of replacing units?
        //
        //     stage = stages[stage.reference]
        // }©

        let units = []
        if(stage.units != undefined) {
            units = stage.units
        } else {
            units = units.concat(Object.values(stage.world.units))
        }

        stage.units = {}
        Objdict.forEach(Objdict.convert(units), (unit) => {
            if(unit.day != undefined
            && unit.day > player.day) {
                return
            }
            stage.units[unit.key] = Unit.instantiate({
                unit, player, gameSlug, chapterSlug, "random": stage.random
            })
        })

        stage.player = Player.copy(player)

        // // Instantiate out-of-zone instances of every unit for repositioning during prepare phase
        // if(hasPreparePhase == true) {
        //     Object.values(player.party.units).forEach((unit) => {
        //         stage.units[unit.key] = Unit.instantiate({player, chapterParty, "unit": {
        //             "key": unit.key,
        //             "position": {"x": -10, "y": -10, "z": 0},
        //             "isRemoved": true,
        //         }, "random": stage.random})
        //     })
        // }

        // // TODO: THIS SHOULDN'T JUST NUKE IT, IT SHOULD MERGE
        // // IT WITH ANY CHANGES...? THE PROTOSTAGE HAS DECLARED.
        // // ALSO, WE SHOULD MOVE THIS TO A WORLD STATIC LOAD CLASS!
        // if(stage.world.reference != undefined) {
        //     if(worlds[stage.world.reference] == undefined) {
        //         throw new Error("Could not find world with reference " + stage.world.reference)
        //     }
        //     let mergedWorld = deepclone(worlds[stage.world.reference])
        //
        //     const alteredWorld = {"reference": stage.world.reference}
        //     mergedWorld = merge(mergedWorld, alteredWorld)
        //
        //     // if(stage.world.terrain != undefined) {
        //     //     // const alteredTerrain = stage.world.terrain.map((terrain, key) => {
        //     //     //     if(terrain.position == undefined) {
        //     //     //         throw "Could not instantiate terrain without position"
        //     //     //     }
        //     //     //     terrain.position = terrain.position
        //     //     //     terrain.shape = terrain.shape || "block"
        //     //     //     terrain.z = terrain.position.z // AREN'T WE OBSOLETING THIS?
        //     //     //     terrain.key = terrain.key || terrain.position.x + "x" + terrain.position.y
        //     //     //     return terrain
        //     //     // })
        //     //     // console.log(alteredTerrain, mergedWorld)
        //     //     // mergedWorld.terrain = Objdict.merge(mergedWorld.terrain, alteredTerrain)
        //     // }
        //     // MERGE IN MORE PROPERTIES, BUT DEEPLY!!
        //
        //     stage.world = mergedWorld
        // }

        stage.world.blocks = stage.world.blocks || []
        stage.world.edges = stage.world.edges || []
        stage.world.terrain =  World.convertBlocksToTerrain(Object.values(stage.world.blocks)) || stage.world.terrain || {}
        stage.world.spots = stage.world.spots || {}
        // world setup!!
        // "blocks": {"x": 0, "y": 0, "z": 0, xy, xyz},
        // "edges": {"0x0x0/0x+1": {}},
        // terrain: {"0x0": {"position": {"x": 0, "y": 0, "z": 0}, "size": {"x": 1, "y": 1, "z": 1}}}
        // "spots": {"name": {"position": {"x": 0, "y": 0, "z": 1}}}
        // zones
        // x1, x2, y1, y2
        // center
        // area
        // color?? name?
        // conditions?? events???

        Dev.havePlayunitsBeenModified = false

        if(stage.world.zones != undefined) {
            stage.encounters = stage.world.zones
            Object.values(stage.encounters).forEach((encounter) => {
                encounter.scripts = stage.scripts
                encounter.events = stage.events
            })
        }

        if(startingEncounter != undefined) {
            stage.currentEncounterKey = startingEncounter
        } else {
            stage.currentEncounterKey = "1" // TODO: how to define the default starting encounter?
        }
        stage.turn = {"number": 0, "affiliation": stage.player.affiliation, "phase": "start"}
        // stage.actionMark = 0
        // stage.zone = 0

        // stage.success = stage.success || {"type": "defeat-all-units"} // TODO: qualify this as the player's success?
        // stage.failure = stage.failure || {"type": "defeat-all-units"} // TODO: qualify this as the player's failure?

        // TODO: Even if a stage is passed, search it for properties
        // that need to be deserialized or defaulted like base stats on units!
        // Or maybe the stage is defined but the map is a reference.

        stage.flags = stage.flags || {}
        Object.values(stage.player.party.units).forEach((unit) => {
            if(stage.units[unit.key] != undefined
            && unit.isRecruited == true
            && unit.isDead != true) {
                stage.flags[unit.key + "_here"] = true
            } else {
                stage.flags[unit.key + "_here"] = false
            }
        })

        return stage
    }
    static findUnitAtPosition(stage, position, options) {
        return Stage.findUnitsByPosition(stage, position, options)[0]
    }
    static findUnitByPosition(stage, position, options = {}) {
        if(position == undefined) return
        const units = Stage.findUnitsByPosition(stage, position, options)

        if(units.length >= 2) {
            units.sort((a, b) => {
                if((a.stack || 0) > (b.stack || 0)) return -1
                if((a.stack || 0) < (b.stack || 0)) return +1
                return 0
            })
        }

        return units[0]
    }
    static findUnitsByPosition(stage, position, options = {}) {
        if(options.excludeUnitKey instanceof Array == false) {
            if(options.excludeUnitKey != undefined) {
                options.excludeUnitKey = [options.excludeUnitKey]
            } else {
                options.excludeUnitKey = []
            }
        }
        return Object.values(stage.units).filter((unit) => {
            if(unit.isDead) return false
            if(unit.isRemoved) return false
            if(options.excludeUnitKey.includes(unit.key)) return false
            if((unit.type == "zone" || unit.type == "spot")
            && Dev.inProtoMode == false) {
                if(!(options.includingSpawnZones && unit.type == "spawn-zone")
                && !options.includingZones) {
                    return false
                }
            }
            return unit.position.x == position.x
                && unit.position.y == position.y
                && (unit.position.z == position.z || position.z == undefined)
        })
    }
    static findUnitInDirection(stage, position, direction, range) {
        let distance = 0
        let previousPosition = Geometry.add(position, {"x": 0, "y": 0})
        let nextPosition = Geometry.add(position, direction)

        while(Stage.hasCollision({stage, previousPosition, nextPosition, "options": {"isIgnoringLedges": true}}) == false) {
            distance += 1
            if(range != undefined && distance >= range.max) break
            vector = Geometry.multiply(direction, distance)
            previousPosition = Geometry.add(position, vector)
            nextPosition = Geometry.add(position, vector, direction)
        }

        // if(distance == 0) couldn't go far in any direction, but did find a direction
        if(World.hasCollision({
            "world": stage.world, previousPosition, nextPosition,
            "options": {"isIgnoringLedges": true},
            "zone": stage.encounters[stage.currentEncounterKey].zone,
        }) == true) {
            // FOUND A COLLISION
        } else if(Stage.findUnitByPosition(stage, nextPosition) != undefined) {
            return Stage.findUnitByPosition(stage, nextPosition)
        }
    }
    // returns a collision raycast.
    // the positions are a raycast. the end position is the last good position before the collision position.
    // startPosition -----> endPosition || collisionPosition
    // can return no collision if a maxdistance is provided.
    // ignores any collision on the tile it is leaving from
    static findCollisionInDirection({stage, position, direction, maxdistance, options}) {
        if(maxdistance === undefined) {
            maxdistance = Infinity
        }

        const ray = {
            "startPosition": position,
            "direction": direction,

            "endPosition": Geometry.copy(position),
            "vector": {"x": 0, "y": 0},
            "distance": 0,

            "positions": [], // THIS ONE INCLUDES THE COLLISION!!
            "castedPositions": [], // THIS ONE DOES NOT INCLUDE THE COLLISION, AND INCLUDES THE CAST START LOCATION
        }

        while(ray.distance < maxdistance) {
            const previousPosition = ray.endPosition
            const nextPosition = Geometry.add(ray.endPosition, ray.direction)
            ray.positions.push(nextPosition)
            ray.castedPositions.push(previousPosition)

            const collision = Stage.findCollision({stage, previousPosition, nextPosition, options})
            if(collision != undefined) {
                ray.collisionPosition = nextPosition
                ray.collision = collision
                break
            }

            ray.distance += 1
            ray.vector = Geometry.add(ray.vector, direction)
            ray.endPosition = Geometry.add(ray.endPosition, direction)

            if(ray.distance >= maxdistance) {
                ray.castedPositions.push(nextPosition)
                break
            }
        }

        return ray
    }
    static findCollision({stage, previousPosition, nextPosition, options}) {
        if(World.hasCollision({
            "world": stage.world,
            "previousPosition": previousPosition,
            "nextPosition": nextPosition,
            "options": options,
            "zone": stage.encounters[stage.currentEncounterKey].zone,
        })) {
            return {"type": "world", "position": nextPosition}
        }
        const unit = Stage.findUnitByPosition(stage, nextPosition)
        if(unit != undefined) {
            return {"type": "unit", "position": nextPosition, "unit": unit}
        }
    }
    static hasCollision({stage, previousPosition, nextPosition, position, options}) {
        nextPosition = nextPosition || position
        previousPosition = previousPosition || position
        if(World.hasCollision({
            "world": stage.world,
            "previousPosition": previousPosition,
            "nextPosition": nextPosition,
            "options": options,
            "zone": stage.encounters[stage.currentEncounterKey].zone,
        })) {
            return true
        }
        if(Stage.findUnitByPosition(stage, nextPosition, options)) {
            return true
        }
        return false
    }

    static hasMetCondition(stage, condition, zone) {
        if(condition == undefined
        || stage == undefined) {
            return false
        }

        if(condition.encounterKey != undefined
        && condition.encounterKey != stage.currentEncounterKey) {
            return false
        }

        if(condition.condition instanceof Function) {
            return condition.condition(stage)
        }
        if(condition.trigger == "exit") {
            const units = Object.values(stage.units).filter((unit) => {
                return unit.affiliation == condition.affiliation
                    && (zone == undefined || Zone.isInBounds(zone, unit.position))
            })
            const remainingUnits = units.filter((unit) => unit.isDead != true && unit.isRemoved != true)
            const removedUnits = units.filter((unit) => unit.isRemoved)
            if(removedUnits.length > 0
            && remainingUnits == 0) {
                return true
            }
            return false
        }
        if(condition.trigger == "defeat-unit"
        && condition.unitKey != undefined) {
            return stage.units[condition.unitKey] != undefined
                && stage.units[condition.unitKey].isDead == true
        }
        if(condition.trigger == "defeat-all-other-units"
        && condition.unitKey !== undefined) {
            const remainingUnits = Object.values(stage.units).filter((unit) => {
                return unit.isDead != true
                    && unit.isRemoved != true
                    && (zone == undefined || Zone.isInBounds(zone, unit.position))
            })
            return remainingUnits.length == 1
                && remainingUnits[0].key == condition.unitKey
        }
        if(condition.trigger == "defeat-all-units-of-type"
        && condition.unitType !== undefined) {
            const remainingUnits = Object.values(stage.units).filter((unit) => {
                return unit.type == condition.unitType
                    && (unit.isDead != true && unit.isRemoved != true)
                    && (zone == undefined || Zone.isInBounds(zone, unit.position))
            })
            return remainingUnits.length == 0
        }
        if(condition.trigger == "defeat-all-units-of-affiliation"
        && condition.affiliation !== undefined) {
            let currentZone = stage.encounters[condition.encounterKey] || zone
            const remainingUnits = Object.values(stage.units).filter((unit) => {
                return unit.affiliation == condition.affiliation
                    && (unit.isDead != true && unit.isRemoved != true)
                    && Zone.isInBounds(currentZone, unit.position)
            })
            return remainingUnits.length == 0
        }
        if(condition.trigger == "defeat-all-unaffiliated-units"
        && condition.affiliation !== undefined) {
            const undefeatedUnit = Objdict.find(stage.units, (unit) => {
                return unit.affiliation != condition.affiliation
                    && unit.affiliation != "none"
                    && unit.isDead != true
                    && (zone == undefined || Zone.isInBounds(zone, unit.position))
            })
            return undefeatedUnit == undefined
        }
        if(condition.trigger == "wait-x-turns"
        && condition.turnNumber != undefined) {
            return stage.turn.number >= condition.turnNumber
        }
    }

    static copy(alphastage) {
        const omegastage = {
            "units": Objdict.map(alphastage.units, (unit) => Unit.copy(unit)),
            "world": alphastage.world,

            "turn": {
                "number": alphastage.turn && alphastage.turn.number || 0,
                "affiliation": alphastage.turn && alphastage.turn.affiliation,
                "phase": alphastage.turn && alphastage.turn.phase,
            },
            "flags": {...alphastage.flags},
            // "zone": alphastage.zone,
            // "actionMark": alphastage.actionMark, // we still using this?
            // "light": alphastage.light,
            "player": Player.copy(alphastage.player),

            "encounters": alphastage.encounters,
            "currentEncounterKey": alphastage.currentEncounterKey,
            "activeEncounterKeys": alphastage.activeEncounterKeys,
            "events": alphastage.events,

            "chapterSlug": alphastage.chapterSlug,

            "hud": alphastage.hud,
            "scripts": alphastage.scripts,

            // TO DEPRECATE, ALL OF THE BELOW:
            "success": alphastage.success,
            "failure": alphastage.failure,
            "phase": alphastage.phase,
            "dialogue": alphastage.dialogue && {
                "text": alphastage.dialogue.text,
                "data": alphastage.dialogue.data,
                "portraitScene": alphastage.dialogue.portraitScene,
                "index": alphastage.dialogue.index,
                "type": alphastage.dialogue.type,
                "speakingCharacter": alphastage.dialogue.speakingCharacter,
                "tags": Objdict.map(alphastage.dialogue.tags, (value, key) => value),
                "characters": Objdict.map(alphastage.dialogue.characters, (character) => {
                    return {
                        "tags": Objdict.map(character.tags, (value, key) => value)
                    }
                }),
            },
            "slug": alphastage.slug,
            "image": alphastage.image,
            "images": alphastage.images,
            "imageOffset": alphastage.imageOffset,
            "loopCount": alphastage.loopCount,
            "configuration": alphastage.configuration,
            "camera": alphastage.camera,
            "random": alphastage.random,
        }
        // TODO: suport a less embedded test stubbing for skill id gen???
        if(alphastage.idgen !== undefined) {
            omegastage.idgen = alphastage.idgen
        }
        return omegastage
    }

    //////////////
    // SCORING //
    ////////////

    // static deltascore(alphastage, omegastage, affiliation) {
    //     const TARGET_PRIORITY = {
    //         "good": 100,
    //         "bad": 100,
    //         "none": 50,
    //     }
    //     const alphascore = Stage.score(alphastage, affiliation)
    //     const omegascore = Stage.score(omegastage, affiliation)
    //     let score = alphascore - omegascore
    //     // score = Math.min(1, score / MAX_SCORE)
    //
    //     return score
    // }

    // Does not (yet) set the action.score, just returns the score.
    // Lets you pass in a different stage from action.stage for predictive logic.
    static score({action, stage, alliedAffiliation}) {
        stage = stage || action.omegastage

        const scores = {}

        // INFLUENCES //
        let influenceScore = 0
        // let influenceCount = 0
        if(action.influenceMap != undefined) {
            const omegaperformer = stage.units[action.performerKey]
            if(omegaperformer != undefined) {
                influenceScore = Stage.getInfluenceScore(action.influenceMap, omegaperformer.position)
            }
            // influenceCount += 1

            // if(omegaperformer.effects != undefined) {
            //     Objdict.forEach(omegaperformer.effects, (effect) => {
            //         if(effect.type == "trap") {
            //             effect.positions.forEach((position) => {
            //                 influenceScore += Stage.getInfluenceScore(action.influenceMap, position)
            //                 influenceCount += 1
            //             })
            //         }
            //     })
            // }
        }
        // Note well! A smaller influence percent is a better influence!!
        scores.influence = influenceScore / MAX_INFLUENCE // (MAX_INFLUENCE * influenceCount)

        // ACTION TYPE //
        scores.type = action.type

        // PROGRESS TOWARDS GOALS //
        function calculateProgressScore(units, isIncluded) {
            const status = {"maxhealth": 0, "health": 0, "maxcount": 0, "count": 0, "score": 0}

            Objdict.forEach(stage.units, (unit) => {
                if(isIncluded(unit) != true) return

                status.maxhealth += unit.maxhealth
                status.health += unit.health
                status.maxhealth += unit.maxarmor || 0
                status.health += unit.armor || 0

                status.maxcount += 1
                status.count += unit.isDead || unit.deathTimer != undefined ? 0 : 1

                status.score += unit.score || 0
            })

            return {
                "count": status.count, // / status.maxcount,
                "health": status.health,  // / status.maxhealth,
                "score": status.score,
                "status": status,
            }
        }

        scores["enemy"] = calculateProgressScore(stage.units, (unit) => unit.affiliation != alliedAffiliation && unit.affiliation != "none" && unit.affiliation != "inanimate" && unit.role != "barrel")
        scores["ally"] = calculateProgressScore(stage.units, (unit) => unit.affiliation == alliedAffiliation && unit.affiliation != "none")
        scores["none"] = calculateProgressScore(stage.units, (unit) => unit.affiliation == "none")
        scores["plants"] = calculateProgressScore(stage.units, (unit) => unit.role == "plant")
        scores["flames"] = calculateProgressScore(stage.units, (unit) => unit.role == "flame")
        scores["barrel"] = calculateProgressScore(stage.units, (unit) => unit.role == "barrel")
        scores["non-player-enemies"] = calculateProgressScore(stage.units, (unit) => {
            return unit.affiliation != alliedAffiliation
                && unit.affiliation != stage.player.affiliation
                && unit.affiliation != "none"
                && unit.affiliation != "nothing"
                && unit.affiliation != undefined
        })

        // All other factions are considered an enemy faction and will be targeted.
        // Do we want to eventually let factions by allies to each other? Like the
        // green faction won't target your units, but you don't control them? Then
        // we'll need a faction data set for who targets who.
        // The none faction is an exception. Is neither ally or enemy. Is this a
        // faction that is considered a lesser target? Are they still targetable
        // by a faction in the who targets who? The same might apply for other
        // factions later, like a red ai who targets your blue faction over the
        // npc green faction

        return scores
    }
    static getInfluenceScore(influenceMap, position) {
        return influenceMap[position.x + "x" + position.y]
    }
    static flattenActionMap(actionmap) {
        let actions = []
        Objdict.forEach(actionmap, (actionmaplist) => {
            actions = actions.concat(actionmaplist)
        })
        return actions
        // // By flattening a unit's action map, each possible position
        // // will have one and only one action, scored as the "best."
        // // In most cases, this is just different directions of approaching
        // // that same action type from different previous positions.
        // return Objdict.map(actionmap, (actionmaplist) => {
        //     return actionmaplist[0]
        // })
    }
    // Stage.isBetterScore(a, b)
    // returns true if (a) is a better score than (b)
    static isBetterScore(a, b, unit) {
        // if(a.ally.score < b.ally.score) return true
        // if(a.ally.score > b.ally.score) return false

        if(unit?.ai?.behaviors != undefined
        && unit.ai.behaviors.includes("healing first")) {
            if(a.ally.health > b.ally.health) return true
            if(a.ally.health < b.ally.health) return false
        }

        if(unit.ai?.behaviors?.includes("always attacks plants first")) {
            if(a["plants"].count < b["plants"].count) return true
            if(a["plants"].count > b["plants"].count) return false
            if(a["plants"].health < b["plants"].health) return true
            if(a["plants"].health > b["plants"].health) return false
        }

        if(unit.ai?.behaviors?.includes("always attacks flames first")) {
            if(a["flames"].count < b["flames"].count) return true
            if(a["flames"].count > b["flames"].count) return false
            if(a["flames"].health < b["flames"].health) return true
            if(a["flames"].health > b["flames"].health) return false
        }

        if(unit.ai?.behaviors?.includes("always attacks non-player-enemies first")) {
            if(a["non-player-enemies"].count < b["non-player-enemies"].count) return true
            if(a["non-player-enemies"].count > b["non-player-enemies"].count) return false
            if(a["non-player-enemies"].health < b["non-player-enemies"].health) return true
            if(a["non-player-enemies"].health > b["non-player-enemies"].health) return false
        }

        if(unit.state != "afraid") { // book
            if(a.enemy.count < b.enemy.count) return true
            if(a.enemy.count > b.enemy.count) return false
            if(a.enemy.health < b.enemy.health) return true
            if(a.enemy.health > b.enemy.health) return false
        }

        if(unit.state != "idle"
        && unit.state != "defensive") {
            if(unit.state == "afraid"
            || unit?.ai?.behaviors?.includes("avoiding")) {
                if(a.influence > b.influence) return false
                if(a.influence < b.influence) return true
            } else {
                if(a.influence > b.influence) return true
                if(a.influence < b.influence) return false
            }
        }

        if(a.ally.count > b.ally.count) return true
        if(a.ally.count < b.ally.count) return false
        if(a.ally.health > b.ally.health) return true
        if(a.ally.health < b.ally.health) return false

        if(a["barrel"].count < b["barrel"].count) return true
        if(a["barrel"].count > b["barrel"].count) return false
        if(a["barrel"].health < b["barrel"].health) return true
        if(a["barrel"].health > b["barrel"].health) return false

        const types = ["invoke skill", "move", "wait"]
        if(types.indexOf(a.type) > types.indexOf(b.type)) return true
        if(types.indexOf(a.type) < types.indexOf(b.type)) return false

        if(a.distance < b.distance) return -1
        if(a.distance > b.distance) return +1

        // TODO: filter out a and b for .type == -1?
        // or just leave that to a separate isInvalidAction?
    }
    static isInvalidAction(action) {
        // TODO: why do we even keep these invalid actions around?
        if(action.type == "move through") {
            return true
        }
    }

    ////////////////
    // NEXT TURN //
    //////////////

    static calculateNextTurn(stage, options = {}) {
        stage.nextTurn = Stage.getNonPlayerSteps(stage, options)
    }
    static getNonPlayerSteps(stage, options = {}) {
        const action = {
            "steps": [],
            "omegastage": stage,
            "aiActions": [],
        }

        // END PLAYER TURN
        Action.addStep(action, Stage.getEndOfTurnSkillSteps(action.omegastage))
        Action.addStep(action, Stage.getEndTurnSteps(action.omegastage.player.affiliation, action.omegastage))
        Action.addStep(action, Stage.getEnergyRefresh(action.omegastage))
        Action.addStep(action, Stage.getEventSteps(action.omegastage, "turn:every:end"))
        Action.addStep(action, Stage.getEventSteps(action.omegastage, "turn:every-even:end"))
        Action.addStep(action, Stage.getEventSteps(action.omegastage, "turn:" + action.omegastage.turn.number + ":end"))
        Action.addStep(action, Stage.getConditionalSteps(action))
        if(action.isTerminated) return action

        // START ENEMY TURN
        Action.addStep(action, Stage.getStartTurnSteps("bad", action.omegastage))
        Action.addStep(action, Stage.getStartOfTurnSkillSteps(action.omegastage))
        Action.addStep(action, Stage.getEventSteps(action.omegastage, "turn:every:start"))
        Action.addStep(action, Stage.getEventSteps(action.omegastage, "turn:every-odd:start"))
        Action.addStep(action, Stage.getEventSteps(action.omegastage, "turn:" + action.omegastage.turn.number + ":start"))
        Action.addStep(action, Stage.getConditionalSteps(action))
        if(action.isTerminated) return action

        const aiAffiliations = ["good", "neutral", "purple", "orange", "blue", "red", 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, "bad"]
        if(options.ignoreAI != true) {
            aiAffiliations.forEach((affiliation) => {
                if(affiliation == action.omegastage.player.affiliation) return
                const ai = Stage.getAiSteps(affiliation, action.omegastage)
                action.aiActions = action.aiActions.concat(ai.actions)
                Action.addStep(action, ai.steps)
            })
        }

        // END ENEMY TURN
        Action.addStep(action, Stage.getEndOfTurnSkillSteps(action.omegastage))
        Action.addStep(action, Stage.getEndTurnSteps("bad", action.omegastage))
        Action.addStep(action, Stage.getEnergyRefresh(action.omegastage))
        Action.addStep(action, Stage.getEventSteps(action.omegastage, "turn:every:end"))
        Action.addStep(action, Stage.getEventSteps(action.omegastage, "turn:every-odd:end"))
        Action.addStep(action, Stage.getEventSteps(action.omegastage, "turn:" + action.omegastage.turn.number + ":end"))
        Action.addStep(action, Stage.getEndRoundSteps(action.omegastage))
        Action.addStep(action, Stage.getConditionalSteps(action))
        if(action.isTerminated) return action

        // START PLAYER TURN
        Action.addStep(action, Stage.getStartTurnSteps("good", action.omegastage))
        Action.addStep(action, Stage.getStartOfTurnSkillSteps(action.omegastage))
        Action.addStep(action, Stage.getEventSteps(action.omegastage, "turn:every:start"))
        Action.addStep(action, Stage.getEventSteps(action.omegastage, "turn:every-even:start"))
        Action.addStep(action, Stage.getEventSteps(action.omegastage, "turn:" + action.omegastage.turn.number + ":start"))
        Action.addStep(action, Stage.getConditionalSteps(action))
        if(action.isTerminated) return action

        return action
    }
    static getConditionalSteps(action) {
        if(action.omegastage.encounters[action.omegastage.currentEncounterKey] != undefined
        && action.omegastage.encounters[action.omegastage.currentEncounterKey].scripts != undefined) {
            const encounter = action.omegastage.encounters[action.omegastage.currentEncounterKey]
            encounter.scripts.forEach((condition) => {
                if(Stage.hasMetCondition(action.omegastage, condition, encounter.zone)) {
                    if(condition.events != undefined) {
                        if(condition.events.length == 0) return
                        const conditionEvents = condition.events
                        conditionEvents.unshift({
                            "name": "SavestateCapture",
                            "savestateSlug": condition.title || "Condition_" + encounter.scripts.indexOf(condition),
                            "omegastage": action.omegastage,
                        })
                        const steps = Stage.processEventSteps(action.omegastage, conditionEvents)
                        Action.addStep(action, steps)
                    }
                }
            })
            if(action.steps.find((step) => step.type == "restart")) {
                action.isTerminated = true
            }
            if(encounter != action.omegastage.encounters[action.omegastage.currentEncounterKey]) {
                action.isTerminated = true
            }
            if(action.omegastage.phase == "failure") {
                action.isTerminated = true
            }
            if(action.omegastage.phase == "success") {
                action.isTerminated = true
            }
        }
    }
    static getEnergyRefresh(stage) {
        return [
            Step.instantiate({
                "type": "refresh",
                "alphastage": stage,
                "deltastages": [
                    {
                        "units": Objdict.map(stage.units, (unit) => {
                            return {
                                "energy": {
                                    "move": true,
                                    "invoke skill": true,
                                    "1": true,
                                    "2": true,
                                    "hasActedOnce": false,
                                    "invokeCount": 0,
                                },
                            }
                        })
                    }
                ]
            })
        ]
    }
    static getStartTurnSteps(affiliation, stage) {
        return [
            Step.instantiate({
                "alphastage": stage,
                "duration": 1000 + 200,
                "deltastages": [
                    {
                        "dialogue": {
                            "type": "TurnStart",
                            "data": {"affiliation": affiliation},
                        }
                    }
                ]
            }),
            Step.instantiate({
                "type": "refresh",
                "alphastage": stage,
                "deltastages": [
                    {
                        "turn": {
                            "affiliation": affiliation,
                            "number": stage.turn.number + 1,
                            "phase": "start",
                        },
                    }
                ]
            })
        ]
    }
    static getEndTurnSteps(affiliation, stage) {
        return [
            Step.instantiate({
                "type": "refresh",
                "alphastage": stage,
                "deltastages": [
                    {
                        "turn": {
                            "affiliation": stage.turn.affiliation,
                            "number": stage.turn.number,
                            "phase": "end",
                        },
                    }
                ]
            })
        ]
    }
    static getEndRoundSteps(stage) {
        if(stage.activeEncounterKeys != undefined) {
            const currentEncounterIndex = stage.activeEncounterKeys.indexOf(stage.currentEncounterKey)
            const nextEncounterKey = stage.activeEncounterKeys[(currentEncounterIndex + 1) % stage.activeEncounterKeys.length]
            return Step.instantiate({
                "alphastage": stage,
                "deltastages": [
                    {
                        "currentEncounterKey": nextEncounterKey
                    }
                ]
            })
        }
    }
    static getEndOfTurnTileSteps(stage) {
        const steps = []
        // let alphastage = stage
        // if(stage.success != undefined
        // && stage.success.condition == "escape") {
        //     stage.success.positions.forEach((position) => {
        //         Objdict.forEach(alphastage.units, (unit) => {
        //             if(unit.isDead != true
        //             && Geometry.equals(unit.position, position)
        //             && unit.affiliation == stage.success.affiliation) {
        //                 const step = Step.instantiate({
        //                     "type": "escape",
        //                     "alphastage": alphastage,
        //                     "deltastages": [{
        //                         "annotation": {"type": "escape", "startPosition": unit.position},
        //                         "units": {
        //                             [unit.key]: {
        //                                 "isDead": true,
        //                                 "isRemoved": true,
        //                             }
        //                         }
        //                     }]
        //                 })
        //
        //                 alphastage = step.omegastage
        //                 steps.push(step)
        //             }
        //         })
        //     })
        // }
        return steps
    }
    static getStartOfTurnSkillSteps(stage, options = {}) {
        let steps = []
        let alphastage = stage

        // TODO: what is the order of unit and skills at the end-of-turn?
        Objdict.forEach(stage.units, (unit) => {
            const alphaunit = alphastage.units[unit.key]
            if(alphaunit.isDead == true) return
            if(alphaunit.isRemoved == true) return
            Objdict.forEach(alphaunit.skillKeys, (skillKey) => {
                const skill = skills.get(skillKey)
                if(skill != undefined) {
                    if(skill.type == "at-start-of-turn"
                    || (skill.type == "at-start-of-my-turn" && alphastage.turn.affiliation == alphaunit.affiliation)
                    || (skill.type == "at-start-of-player-turn" && alphastage.turn.affiliation == stage.player.affiliation)) {
                        if(skill.canTarget instanceof Function == false
                        || skill.canTarget({"performerKey": alphaunit.key, "position": alphaunit.position, "stage": alphastage}) == true) {
                            if(skill.calculateStep instanceof Function) {
                                const step = skill.calculateStep({
                                    "performerKey": alphaunit.key,
                                    "stage": alphastage,
                                })

                                alphastage = step.omegastage
                                steps.push(step)
                            }
                        }
                    }
                }
            })
        })

        steps = steps.concat(Reactions.getSteps(alphastage))

        return steps
    }
    static getEndOfTurnSkillSteps(stage, options = {}) {
        let steps = []
        let alphastage = stage

        // TODO: what is the order of unit and skills at the end-of-turn?
        Objdict.forEach(stage.units, (unit) => {
            const alphaunit = alphastage.units[unit.key]
            if(alphaunit.isDead == true) return
            if(alphaunit.isRemoved == true) return
            Objdict.forEach(unit.effects, (effect, effectKey) => {
                const alphaeffect = alphaunit.effects[effectKey]
                if(alphaeffect.timer != undefined) {
                    if(alphaeffect.timer - 1 <= 0) {
                        // if(alphaeffect.type == "fuse"
                        // && alphaeffect.skillKey != undefined
                        // && skills.get(alphaeffect.skillKey) != undefined) {
                        //     const step = skills.get(alphaeffect.skillKey).calculateStep({
                        //         "performerKey": alphaunit.key,
                        //         "effectKey": effectKey,
                        //         "position": alphaunit.position,
                        //         "stage": alphastage,
                        //     })
                        //     step.skillKey = alphaeffect.skillKey
                        //     step.type = "invoke skill"
                        //
                        //     Objdict.forEach(step.omegastage.units, (unit) => {
                        //         if(unit.health <= 0
                        //         && unit.isDead != true) {
                        //             Step.add(step, {"units": {[unit.key]: {"isDead": true}}})
                        //         }
                        //     })
                        //
                        //     alphastage = step.omegastage
                        //     steps.push(step)
                        // } else {
                        const step = Step.instantiate({
                            "type": "remove effect",
                            "alphastage": alphastage,
                            "deltastages": [{
                                "units": {
                                    [alphaunit.key]: {
                                        "effects": {
                                            [effectKey]: undefined
                                        }
                                    }
                                }
                            }]
                        })

                        alphastage = step.omegastage
                        steps.push(step)
                    } else {
                        const step = Step.instantiate({
                            "type": "decrement effect timer",
                            "alphastage": alphastage,
                            "deltastages": [{
                                "units": {
                                    [alphaunit.key]: {
                                        "effects": {
                                            [effectKey]: { // TODO: why isn't alphaeffect.key not defined :<
                                                "timer": alphaeffect.timer - 1,
                                            }
                                        }
                                    }
                                }
                            }]
                        })

                        alphastage = step.omegastage
                        steps.push(step)
                    }
                }

                // // this doesn't work, for whatever reason.
                // // just going to do something different.
                if(alphaeffect.type == "at-end-of-turn"
                && alphaeffect.skillKey != undefined) {
                    const skill = skills.get(alphaeffect.skillKey)
                    if(skill != undefined) {
                        if(skill.canTarget instanceof Function == false
                        || skill.canTarget({"performerKey": alphaunit.key, "position": alphaunit.position, "stage": alphastage}) == true) {
                            if(skill.calculateDeltastages instanceof Function) {
                                step = Step.instantiate({
                                    "type": "invoke skill",
                                    "alphastage": alphastage,
                                    "skillKey": alphaeffect.skillKey, // wait do i still need to do this? i don't think we do.
                                    "deltastages": skill.calculateDeltastages({
                                        "performerKey": alphaunit.key, // wait, you're performing it on yourself? because it's your effect?
                                        "position": alphaunit.position,
                                        "stage": alphastage,
                                    })
                                })
                            } else if(skill.calculateStep instanceof Function) {
                                step = skill.calculateStep({
                                    "performerKey": alphaunit.key,
                                    "position": alphaunit.position,
                                    "stage": alphastage,
                                })
                            }

                            alphastage = step.omegastage
                            steps.push(step)
                        }
                    }
                }
            })
            Objdict.forEach(alphaunit.skillKeys, (skillKey) => {
                const skill = skills.get(skillKey)
                if(skill != undefined) {
                // && (alphastage.turn.number + (options.turnNumber || 0)) % 2 == 1) {
                // && (alphaunit.affiliation == "good" && alphastage.turn.number % 2 == 0
                // || alphaunit.affiliation == "bad" && alphastage.turn.number % 2 != 0)) {
                    if(skill.type == "at-end-of-turn"
                    || (skill.type == "at-end-of-bad-turn" && alphastage.turn.affiliation == "bad")
                    || (skill.type == "at-end-of-my-turn" && alphastage.turn.affiliation == alphaunit.affiliation)
                    || (skill.type == "at-end-of-player-turn" && alphastage.turn.affiliation == stage.player.affiliation)) {
                        if(skill.canTarget instanceof Function == false
                        || skill.canTarget({"performerKey": alphaunit.key, "position": alphaunit.position, "stage": alphastage}) == true) {
                            let step = undefined
                            if(skill.calculateDeltastages instanceof Function) {
                                step = Step.instantiate({
                                    "type": "invoke skill",
                                    "alphastage": alphastage,
                                    "skillKey": skillKey, // I hate this
                                    "deltastages": skill.calculateDeltastages({
                                        "performerKey": alphaunit.key,
                                        "position": alphaunit.position,
                                        "stage": alphastage,
                                    })
                                })
                            } else if(skill.calculateStep instanceof Function) {
                                step = skill.calculateStep({
                                    "performerKey": alphaunit.key,
                                    "stage": alphastage,
                                })
                            }

                            // TODO: this is making a step & animation
                            // for every unitzone that has this skill.
                            // can we return undefined if there is
                            // no step to be performed?

                            alphastage = step.omegastage
                            steps.push(step)
                        }
                    }
                }
            })
        })

        // deaths and stuff:
        steps = steps.concat(Reactions.getSteps(alphastage))
        if(steps.length > 0) {
            alphastage = steps[steps.length - 1].omegastage
        }

        return steps
    }

    static getAiSteps(affiliation, stage) {
        const turn = {
            "steps": [],
            "actions": {} // by unit key
        }

        const units = Object.values(stage.units).filter((unit) => {
            if(unit.affiliation != affiliation) return false
            if(unit.isDead == true) return false
            if(unit.isRemoved == true) return false
            if(unit.state == "pacified") return false
            if(unit.state == "passive") return false
            if(Zone.isInBounds(stage.encounters[stage.currentEncounterKey].zone, unit.position) == false) return false
            return true
        })

        let alphastage = stage
        units.forEach((unit) => {
            const actionmap = Unit.calculateActions(unit.key, alphastage) // we really recalculating this huh
            let actions = Stage.flattenActionMap(actionmap)

            if(actions.length == 0) return

            if(unit.state == "unpredictable") {
                const randomAction = stage.random.element(actions.filter((action) => action.type == "move"))
                turn.actions[unit.key] = {"action": randomAction, "actionmap": actionmap}
                turn.steps = turn.steps.concat(randomAction.steps)
                alphastage = turn.steps[turn.steps.length - 1]?.omegastage
                return
            }

            actions.sort((a, b) => {
                if(a.distance < b.distance) return -1
                if(a.distance > b.distance) return +1
                return 0
            })

            let bestAction = undefined
            actions.forEach((action) => {
                if(Stage.isInvalidAction(action)) {
                    return action
                }

                // TODO: This should be far less verbose... Pull in the Step.js class?? as Sequence.js?
                // action.predictiveSteps = action.steps.concat(Stage.getEndOfTurnSkillSteps(action.omegastage))
                // action.predictiveOmegastage = action.predictiveSteps[action.predictiveSteps.length-1].omegastage
                // // action.predictiveSteps = action.predictiveSteps.concat(Stage.getEndOfTurnSkillSteps(action.predictiveOmegastage, {"turnNumber": +1}))
                // // action.predictiveOmegastage = action.predictiveSteps[action.predictiveSteps.length-1].omegastage

                action.score = Stage.score({
                    "stage": action.omegastage,
                    // "stage": action.predictiveOmegastage, // ADDED FOR BOMBER
                    "action": action,
                    "alliedAffiliation": affiliation,
                    "unit": unit,
                })

                if(action.type == "move through") {
                    return
                }

                if(bestAction == undefined
                || Stage.isBetterScore(action.score, bestAction.score, unit)) {
                    bestAction = action
                }
            })

            if(unit.state == "unpredictable-but-defensive"
            && bestAction.type == "move") {
                bestAction = stage.random.element(actions.filter((action) => action.type == "move"))
            }

            if(bestAction != undefined) {
                turn.actions[unit.key] = {"action": bestAction, "actionmap": actionmap}
                turn.steps = turn.steps.concat(bestAction.steps)
                alphastage = turn.steps[turn.steps.length - 1].omegastage
            }
        })

        return turn

        // TODO: Address the hangover of returning actions alongside steps.
        // We need them to render the enemy ui. We really just use action type
        // and action position. We are currently hurting because we're not
        // returning the entire action map (to show enemy range). We need to
        // eventually include order of actions as well, to match the order
        // of steps, so we can maybe animate the enemy intention ui with some
        // slight order-of-operations delay in how it renders out.

        // RECENT //

        // const affiliatedUnits = {}
        // let steps = []
        // let alphastage = stage
        // Objdict.forEach(stage.units, (unit) => {
        //     const alphaunit = alphastage.units[unit.key]
        //     if(alphaunit.affiliation == "bad"
        //     && alphaunit.isDead != true) {
        //         const actionmap = Unit.calculateActions(unit.key, alphastage)
        //         const action = Unit.getBestAction(actionmap)
        //         steps = steps.concat(action.steps)
        //         affiliatedUnits[unit.key] = {action, actionmap}
        //
        //         if(action != undefined) {
        //             alphastage = action.omegastage
        //         }
        //     }
        // })
        // // TODO: ONCe WE HAVE THE BEST ACTION, WE CAN PROBABLY DUMP ALLLLL THE OTHER POSSIBILITIES AS USELESS.
        // return {"affiliatedUnits": affiliatedUnits, "affiliatedSteps": steps}

        // OLDER //

        // this.influence[affiliation] = this.getInfluence(affiliation, shadowunits)
        // TODO: uuuuh if there is any meaningful state change in stage vs
        // alphastagewithheavycomputation, then we need to recompute here.

        // // this is so wasteful, given that
        // // alphastage at the start of this getnonplyaeractions process should have already
        // // computed all of this. or most of this (it doesn't have the start of turn state
        // // changes like effects wearing off)
        // // UUH IS THIS STILL TRUE I REFACTORED IT SO IT ONLY CALCULATES ONCE
        //
        // Objdict.forEach(stage.units, (unit) => {
        //     if(unit.affiliation == affiliation && unit.isDead != true) {
        //         steps = steps.concat(unit.bestAction.steps)
        //         // THIS DOES NOT RESPECT THE ORDER OF THE
        //         // BEST ACTIONS, SO IF YOU EVER CHANGE IT
        //         // SO UNIT ORDER IS DYNAMIC, THIS MUST BE
        //         // RESTRUCTURED ACCORDINGLY
        //     }
        // })
    }
    static getEventSteps(stage, eventKey) {
        let events = []

        if(stage == undefined) {
        // || stage.encounters == undefined
        // || stage.encounters[stage.currentEncounterKey] == undefined) {
            return events
        }

        const encounter = stage.encounters[stage.currentEncounterKey]
        if(encounter != undefined) {
            if(encounter.scripts != undefined) {
                const condition = encounter.scripts.find((condition) => {
                    return condition.trigger == eventKey
                        && (condition.encounterKey == undefined || condition.encounterKey == stage.currentEncounterKey)
                })
                if(condition != undefined) {
                    if(condition.events != undefined && condition.events.length > 0) {
                        const conditionEvents = condition.events
                        conditionEvents.unshift({
                            "name": "SavestateCapture",
                            "savestateSlug": condition.title || "Condition_" + encounter.scripts.indexOf(condition),
                            "omegastage": stage,
                        })
                        events = events.concat(Stage.processEventSteps(stage, conditionEvents))
                    }
                }
            }

            if(encounter.events != undefined
            && encounter.events[eventKey] != undefined) {
                events = events.concat(Stage.processEventSteps(stage, encounter.events[eventKey]))
            }
        }

        if(stage.events != undefined) {
            events = events.concat(Stage.processEventSteps(stage, stage.events))
        }

        events = events.filter((event) => event != undefined)

        return events
    }
    // accepts: an array of either events or subarrays of events.
    // outputs: an new array of all events
    static convertProtostepsIntoSteps(protosteps, alphastage) {
        let outputs = []
        if(protosteps instanceof Array == false) {
            protosteps = [protosteps]
        }
        // protosteps = protosteps.map((protostep) => Step.copy(protostep))
        protosteps.forEach((protostep) => {
            if(protostep instanceof Array) {
                outputs = outputs.concat(Stage.convertProtostepsIntoSteps(protostep, alphastage))
                alphastage = outputs[outputs.length-1]?.omegastage
            } else if(protostep instanceof Function && alphastage != undefined) {
                outputs = outputs.concat(Stage.convertProtostepsIntoSteps(protostep(alphastage), alphastage))
                alphastage = outputs[outputs.length-1]?.omegastage
            } else if(isString(protostep)) {
                // If the protostep is a string, we handle it as Ribbit scripting.
                Ribbit.convertScriptStringToEvents(protostep, alphastage).forEach((line) => {
                    if(line == undefined) return

                    let step = Step.copy(line)
                    step.alphastage = alphastage
                    step = Step.instantiate(step)
                    outputs.push(step)

                    // It is critical we change
                    // the alphastage of the next
                    // step to be the omegastage
                    // of this previous step!!
                    alphastage = step.omegastage
                })
            } else if(protostep != undefined) {
                let step = Step.copy(protostep)
                step.alphastage = alphastage
                step = Step.instantiate(step)
                step.followingProtosteps = protostep.followingProtosteps
                outputs.push(step)

                // It is critical we change
                // the alphastage of the next
                // step to be the omegastage
                // of this previous step!!
                alphastage = step.omegastage

                // When moving out of dialogue into
                // non-dialogue steps, we close the dialogue box
                if(alphastage.dialogue != undefined
                && step?.type != "StartDialogue"
                && step?.type != "ContinueDialogue"
                && step?.type != "FinishDialogue"
                && alphastage.dialogue?.data?.doNotFuckingTouchThis != true) {
                    const step = Step.instantiate({
                        "type": "FinishDialogue",
                        "alphastage": alphastage,
                        "deltastages": [
                            {
                                "mark": 0,
                                "dialogue": undefined
                            }
                        ],
                    })
                    outputs.push(step)

                    alphastage = step.omegastage
                }
            }
        })
        return outputs
    }
    // protosteps in an array of steps.
    // you can embed those protosteps in subarrays.
    // you can return those protosteps from jit functions (passed the stage).
    // you can also calculate the entire top-level array using a jit function.
    static processEventSteps(alphastage, protosteps) {
        if(protosteps == undefined) return []
        if(protosteps instanceof Function) {
            console.warn("We are deprecating the use of a top-level function that returns ALL steps. Instead, please use an array of steps, with a function as just one of the steps that returns the dynamic effect you want. Static steps can remain static, while dynamic steps can be as dyanmic as they want.", protosteps)
            protosteps = protosteps(alphastage)
        }
        if(protosteps instanceof Array != true) {
            protosteps = [protosteps]
        }
        if(protosteps.length == 0) return
        if(protosteps.length == 1 && protosteps[0] == undefined) return
        if(protosteps.length == 1 && protosteps[0].length == 0) return
        // protosteps = protosteps.map((protostep) => Step.copy(protostep))

        let steps = []
        protosteps.forEach((protostep, index) => {
            if(protostep == undefined) {
                return undefined
            }
            if(isString(protostep) == false) {
                protostep.followingProtosteps = protosteps.slice(index + 1).map((step) => Step.copy(step))
            }

            steps = steps.concat(Stage.convertProtostepsIntoSteps(protostep, alphastage))

            if(steps.length > 0) {
                alphastage = steps[steps.length - 1].omegastage
            }
        })

        // At the end of the scene, close any
        // dialogues that might still be open.
        if(alphastage.dialogue != undefined) {
            const step = Step.instantiate({
                "type": "FinishDialogue",
                "alphastage": alphastage,
                "deltastages": [
                    {
                        "mark": 0,
                        "dialogue": undefined
                    }
                ]
            })
            alphastage = step.omegastage
            steps.push(step)
        }

        return steps
    }

    ////////////////
    // YOUR TURN //
    //////////////

    static calculateActions(stage, {force} = {}) {
        const mark = Speedtest.mark("Actions", "Stage.calculateActions")

        if(stage.hasPerformedActionCalculation == true && force != true) {
            return
        }

        Objdict.forEach(stage.units, (unit) => {
            if(stage.encounters[stage.currentEncounterKey] == undefined) return
            if(Zone.isInBounds(stage.encounters[stage.currentEncounterKey].zone, unit.position)) {
                if(unit.affiliation == stage.player.affiliation) {
                    unit.actionmap = Unit.calculateActions(unit.key, stage)
                }
                if(unit.spotTag == "warning") {
                    unit.actionmap = Unit.calculateActions(unit.key, stage)
                }
                // DEUBG: We're not calculating it for all units, depending on affiliation.
                // if(unit.affiliation == "good") {
                //     unit.actionmap = Unit.calculateActions(unit.key, stage)
                // DEBUG // We're now calculating this just-in-time for when you hover over this actionmap option.
                // Object.values(unit.actionmap).forEach((actionlist) => actionlist.forEach((action) => {
                //     Stage.calculateNextTurn(action.omegastage)
                // }))
                // }
            }
        })
        // // We're removing this and only calculating these just before you end your turn.
        // Stage.calculateNextTurn(stage) // DEBUG

        stage.hasPerformedActionCalculation = true
        Stage.calculateLight(stage)

        mark()

        return stage
    }
    static calculateLight(stage) {
        stage.light = {}
        Objdict.forEach(stage.units, (unit) => {
            if(unit.affiliation != "bad") return
            if(unit.type == "zone" || unit.type == "spot") return

            let actionmap = unit.actionmap
            // if(stage.nextTurn != undefined
            // && stage.nextTurn.aiActions != undefined
            // && stage.nextTurn.aiActions[unit.key] != undefined
            // && stage.nextTurn.aiActions[unit.key].actionmap != undefined) {
            //     actionmap = stage.nextTurn.aiActions[unit.key].actionmap
            // }
            // if(actionmap == undefined) return

            Objdict.forEach(actionmap, (actionlist, positionKey) => {
                // const action = Selection.findActionInActionlistToActuallyUse({unit, actionlist, "options": {"ignoreActiveSkill": true}})
                // if(action == undefined) return
                stage.light[positionKey] = true // action.position
            })
        })
    }

    static getScore(stage) {
        let score = undefined
        Object.values(stage.units).forEach((unit) => {
            if(unit.affiliation == stage.player.affiliation
            && unit.score != undefined) {
                score = score || 0
                if(unit.isDead != true
                && unit.isRemoved != true) {
                    score += unit.score
                }
            }
        })
        return score
    }

    static findEncounterAtPosition(stage, position) {
        return Objdict.find(stage.encounters, (encounter, encounterSlug) => {
            return Zone.isInBounds(encounter.zone, position)
        })
    }

    static addUnit(stage, unit) {
        stage.units[unit.key] = unit
    }
    static addItemToInventory(stage, item) {
        item = Stage.readyItemForInventory(stage.player.inventory, item, stage)
        stage.player.inventory.items[item.key] = item
    }
    static readyItemForInventory(inventory, newItem, stage) {
        if(newItem.class == undefined) throw new Error("Item must have a class.")
        newItem.amount = newItem.amount || 1

        const items = Object.values(inventory.items).sort((a, b) => a.slot - b.slot)
        const oldItem = items.find((oldItem) => oldItem.class == newItem.class)
        if(oldItem != undefined) {
            newItem.key = oldItem.key
            newItem.slot = oldItem.slot
            newItem.amount += oldItem.amount || 0
        }

        if(oldItem == undefined) {
            newItem.key = newItem.key || stage.random.identifier(5)
            newItem.slot = 10
            for(let slot = 0; slot < 10; slot += 1) {
                let slotItem = items.find((item) => item.slot == slot)
                if(slotItem == undefined) {
                    newItem.slot = slot
                    break
                }
            }
        }

        return newItem
    }
}

// const directions = [{"x": +1}, {"x": -1}, {"y": +1}, {"y": -1}]
// // TODO: merge this with utilities/Directions.js? Pull them from Geometry.north/etc?
//

class Player {
    static copy(alphaplayer) {
        if(alphaplayer == undefined) return undefined
        return {
            ...alphaplayer,
            // "score": alphaplayer.score,
            // "affiliation": alphaplayer.affiliation,
            // "perks": alphaplayer.perks && Object.values(alphaplayer.perks),
            "inventory": alphaplayer.inventory && {
                "gold": alphaplayer.inventory.gold,
                "items": Objdict.map(alphaplayer.inventory.items, (item) => {
                    const copiedItem = {}
                    for(let key in item) {
                        if(item[key] != undefined) {
                            copiedItem[key] = item[key]
                        }
                    }
                    return copiedItem
                })
            },
            "party": {
                "units": Objdict.map(alphaplayer.party.units, (unit) => unit)
            }
        }
    }
}
